const days_of_week_working =
 [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
 ];
export default days_of_week_working;
